import { useQuery } from '@tanstack/react-query'

import * as PlaceDetailKeys from '../reactQueryKeys/placeDetails'

import { getGoogleExploreItemsPlaceDetails } from 'tripPlanner/api/places'

type Args = {
  placeIds: Array<string | undefined>
}

// Only for Trip Planner usage
export const useTripExplorePlaceDetails = ({ placeIds = [] }: Args) => {
  const filteredPlaceIds = placeIds.filter((val) => val !== undefined)

  return useQuery({
    queryKey: PlaceDetailKeys.googleExplorePlacesDetails(
      filteredPlaceIds.join(','),
    ),
    queryFn: () => getGoogleExploreItemsPlaceDetails(filteredPlaceIds),
    select: (data) => data.items,
    enabled: !!placeIds.some((val) => !!val),
  })
}
